import React from 'react';
import { useTobaccoStore } from '../store/tobacco-use.form-store';
import Fields from './tobacco-use.fields.component';

export default function LoginUser() {
  const loginUser = useTobaccoStore((state) => state.loginUser);

  return <Fields tobaccoUser={loginUser} />;
}
